import React from "react";
import moment from "moment";


const TVClassCard = ({ session }) => {
    // Session provides: activityName, activityColor, employeeName, employeePhotoUrl, startTime, endTime, lessonPlan

    const objectives = session.lessonPlan?.objectives || [];

    const isUpcoming = moment().isBefore(moment(session.startTime, "HH:mm"));

    // Fallbacks para tentar puxar a foto usando diferentes campos possíveis vindos do Firebase
    const photoUrl = session?.employeePhotoUrl || session?.originalEmployeePhotoUrl || session?.instructorPhotoUrl || null;

    return (
        <div 
            className="card shadow-lg mb-0 border-0 rounded-4 overflow-hidden d-flex flex-column"
            style={{ 
                backgroundColor: "rgba(0, 0, 0, 0.85)",
                opacity: isUpcoming ? 0.65 : 1, 
                transition: "all 0.3s ease-in-out" 
            }}
        >
            {/* Top Color Edge */}
            <div 
                className="w-100 py-1" 
                style={{ backgroundColor: session.activityColor || "#556ee6" }}
            ></div>

            <div className="card-body p-3 p-md-4 d-flex flex-column overflow-hidden" style={{ flex: 1, minHeight: 0 }}>
                
                {/* Header: TIME and ACTIVITY */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-2 gap-sm-3 w-100">
                        <div 
                            className="rounded-3 shadow-sm d-flex justify-content-center align-items-center px-2 py-1 px-md-3 py-md-2 fw-bold"
                            style={{ backgroundColor: "#ffffff", color: "#343a40", fontSize: "clamp(1rem, 2vw, 1.4rem)", whiteSpace: "nowrap" }}
                        >
                            <i className="mdi mdi-clock-outline me-1 me-md-2"></i>
                            {session.startTime}
                        </div>
                        <h4 className="mb-0 fw-bold text-white text-truncate" style={{ fontSize: "clamp(1.4rem, 2.5vw, 2rem)" }}>{session.activityName}</h4>
                    </div>
                </div>

                {/* INSTRUCTOR */}
                <div className="d-flex align-items-center mb-4">
                    {photoUrl ? (
                        <img 
                            src={photoUrl} 
                            alt={session.employeeName} 
                            className="rounded-circle shadow-sm me-3 border border-2 border-white"
                            style={{ width: "clamp(50px, 8vw, 70px)", height: "clamp(50px, 8vw, 70px)", objectFit: "cover", flexShrink: 0 }}
                        />
                    ) : (
                        <div 
                            className="rounded-circle shadow-sm me-3 d-flex align-items-center justify-content-center bg-dark text-white border border-2 border-secondary"
                            style={{ width: "clamp(50px, 8vw, 70px)", height: "clamp(50px, 8vw, 70px)", fontSize: "clamp(1.2rem, 2vw, 1.8rem)", fontWeight: "bold", flexShrink: 0 }}
                        >
                            {(session.employeeName || session.originalEmployeeName || "?").charAt(0).toUpperCase()}
                        </div>
                    )}
                    <div className="overflow-hidden text-start">
                        <span className="text-white-50 text-uppercase fw-semibold" style={{ fontSize: "clamp(0.7rem, 1vh, 0.9rem)", letterSpacing: "1px" }}>PROFESSOR</span>
                        <h5 className="mb-0 fw-bold text-white text-truncate" style={{ fontSize: "clamp(1.1rem, 2.5vh, 1.5rem)" }}>{session.employeeName || session.originalEmployeeName || "Não Definido"}</h5>
                    </div>
                </div>

                {/* OBJECTIVES */}
                <div className="d-flex flex-column text-start mt-2" style={{ flexShrink: 1, overflowY: "auto", minHeight: 0, paddingRight: "4px" }}>
                    <span className="text-white-50 text-uppercase fw-bold d-block mb-3 flex-shrink-0" style={{ fontSize: "clamp(0.85rem, 1.3vh, 1rem)", letterSpacing: "1px" }}>OBJETIVOS DA AULA</span>
                    {objectives.length > 0 ? (
                        <div className="d-flex flex-column gap-2 gap-md-3">
                            {objectives.map((obj, index) => (
                                <div 
                                    key={index}
                                    className="d-flex align-items-start"
                                    style={{ 
                                        color: "#ffffff",
                                        fontSize: "clamp(1rem, 2vh, 1.4rem)", 
                                        fontWeight: "600",
                                        lineHeight: "1.3"
                                    }}
                                >
                                    <div 
                                        className="me-2 flex-shrink-0"
                                        style={{ 
                                            width: "4px", 
                                            backgroundColor: "#f1b44c", 
                                            borderRadius: "2px", 
                                            alignSelf: "stretch", 
                                            marginTop: "2px", 
                                            marginBottom: "2px" 
                                        }} 
                                    ></div>
                                    <span>{obj.name}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-white-50 mb-0" style={{ fontStyle: "italic", fontSize: "clamp(1.1rem, 1.8vw, 1.3rem)" }}>
                            Prática livre ou metodologia não cadastrada.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TVClassCard;
